import React from 'react';
import carbonFilter from 'assets/images/carbon-filter.png';
import carbonFilterWebp from 'assets/images/carbon-filter.png?as=webp';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';
import { EMOJI } from '../../../shared/enums';

const FadeIn = loadable(() => import('../common/FadeIn'));

const FullwidthContent = () => (
  <section className='fullwidth-content'>
    <div className='container'>
      <div className='fullwidth-content__header'>
        <h2 className='fullwidth-content__header-title'>She brings 1 lb of heavy-duty granular activated carbon.</h2>
        <h3 className='fullwidth-content__header-description'>
          (the best at filtering harmful VOCs, odors and smelly
          {' '}
          {EMOJI.LOVING_CAT}
          )
        </h3>
      </div>
      <div className='fullwidth-content__body'>
        <div className='fullwidth-content__description'>
          <p>
            Other manufacturers cheat and call a few ounces of carbon
            dust a “carbon filter.” However, filtration of
            gases depends on the weight and depth of activated carbon.
          </p>
          <p>
            Mila’s patent-pending Dual-Flow filter allows her to hold an
            optional 1 lb of granular active carbon in a
            3-inch bed, giving you best-in-class filtration for household
            odors and harmful VOCs from paints, carpets,
            and pressed woods.
          </p>
        </div>
        <figure className='fullwidth-content__image'>
          <LazyLoad height={623} placeholder={<div className='image-placeholder' style={{ aspectRatio: `${842 / 623} ` }} />}>
            <FadeIn>
              <picture>
                <source srcSet={carbonFilterWebp} type='image/webp' />
                <source srcSet={carbonFilter} type='image/png' />
                <img
                  src={carbonFilter}
                  alt='carbon-filter'
                  width={842}
                  height={623}
                />
              </picture>
            </FadeIn>
          </LazyLoad>
        </figure>
      </div>
    </div>
  </section>
);
export default FullwidthContent;
